import React, { useEffect, useState } from "react";
import axios from "../../api/axiosInstance";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import GlobalLoader from "./GlobalLoader";
import EmptyStateCentered from "../static/EmptyStateCentered";

const IgnoredProfilesListPage = () => {
  const [ignoredProfiles, setIgnoredProfiles] = useState([]);
  const [loading, setLoading] = useState(true);

  const user = JSON.parse(localStorage.getItem("user"));
  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");

  const fetchIgnoredProfiles = async () => {
    try {
      setLoading(true);
      const startTime = Date.now();

      const res = await axios.get("/api/ignored-profiles/", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      const elapsed = Date.now() - startTime;
      const remaining = 1000 - elapsed;
      if (remaining > 0) {
        setTimeout(() => {
          setIgnoredProfiles(res.data);
          setLoading(false);
        }, remaining);
      } else {
        setIgnoredProfiles(res.data);
        setLoading(false);
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
      toast.error("Failed to fetch ignored profiles");
      setLoading(false);
    }
  };

  const unignoreProfile = async (receiverId) => {
    try {
      await axios.post(
        "/api/unignore-profile/",
        { receiver_id: receiverId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      );
      toast.success("Profile unignored successfully");
      setIgnoredProfiles((prev) =>
        prev.filter((p) => p.user.id !== receiverId),
      );
    } catch (error) {
      console.error(error.response?.data || error.message);
      toast.error("Failed to unignore profile");
    }
  };

  useEffect(() => {
    fetchIgnoredProfiles();
  }, []);

  if (loading) {
    return <GlobalLoader />;
  }

  return (
    <div className="pt-8 w-full  mx-auto overflow-y-auto">
      {ignoredProfiles.length === 0 ? (
        <p className="text-center text-gray-500 mt-10">
          <EmptyStateCentered />
        </p>
      ) : (
        <div className="flex flex-col gap-4">
          {ignoredProfiles.map((match) => (
            <div
              key={match.id}
              className="bg-white rounded shadow p-4 flex flex-col sm:flex-row items-center sm:items-start gap-4"
            >
              <Link to={`/profile/${match.user.id}`} className="flex-shrink-0">
                <img
                  src={
                    match.photo || require("../../assets/default_image.webp")
                  }
                  alt={`${match.user.first_name}`}
                  className="w-32 h-32 object-cover rounded"
                />
              </Link>

              <div className="flex-1">
                <Link
                  to={`/profile/${match.user.id}`}
                  className="flex-shrink-0 text-decoration-none"
                >
                  <p className="font-semibold text-lg">
                    {match.user.first_name} {match.user.last_name}
                  </p>
                  <p className="text-sm text-gray-600 mb-2">
                    {calculateAge(match.dob)} yrs • {match.height_feet}'
                    {match.height_inches}" • {match.religion} •{" "}
                    {match.marital_status} • {match.highest_education} •{" "}
                    {match.employed_in} • {match.city}
                  </p>
                </Link>
                <div className="mt-4">
                  <button
                    onClick={() => unignoreProfile(match.user.id)}
                    className="bg-pink-600 text-white px-3 py-1 rounded hover:bg-pink-700 transition"
                  >
                    Remove from ignore Profile
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default IgnoredProfilesListPage;
